import { CreatableSelect as Select } from 'chakra-react-select';
import { t } from 'i18next';

type IProps = Omit<React.ComponentProps<typeof Select>, 'onChange'> & {
	onChange?: (value: string) => void;
};

const options = [
	{ label: '08:00', value: '08:00' },
	{ label: '08:30', value: '08:30' },
	{ label: '09:00', value: '09:00' },
	{ label: '09:15', value: '09:15' },
	{ label: '09:30', value: '09:30' },
	{ label: '09:45', value: '09:45' },
	{ label: '10:00', value: '10:00' },
	{ label: '10:15', value: '10:15' },
	{ label: '10:30', value: '10:30' },
	{ label: '10:45', value: '10:45' },
	{ label: '11:00', value: '11:00' },
	{ label: '11:15', value: '11:15' },
	{ label: '11:30', value: '11:30' },
	{ label: '11:45', value: '11:45' },
	{ label: '12:00', value: '12:00' },
	{ label: '12:15', value: '12:15' },
	{ label: '12:30', value: '12:30' },
	{ label: '12:45', value: '12:45' },
	{ label: '13:00', value: '13:00' },
	{ label: '13:15', value: '13:15' },
	{ label: '13:30', value: '13:30' },
	{ label: '13:45', value: '13:45' },
	{ label: '14:00', value: '14:00' },
	{ label: '14:15', value: '14:15' },
	{ label: '14:30', value: '14:30' },
	{ label: '14:45', value: '14:45' },
	{ label: '15:00', value: '15:00' },
	{ label: '15:15', value: '15:15' },
	{ label: '15:30', value: '15:30' },
	{ label: '15:45', value: '15:45' },
	{ label: '16:00', value: '16:00' },
	{ label: '16:15', value: '16:15' },
	{ label: '16:30', value: '16:30' },
	{ label: '16:45', value: '16:45' },
	{ label: '17:00', value: '17:00' },
	{ label: '17:15', value: '17:15' },
	{ label: '17:30', value: '17:30' },
	{ label: '17:45', value: '17:45' },
	{ label: '18:00', value: '18:00' },
	{ label: '18:30', value: '18:30' },
	{ label: '19:00', value: '19:00' },
	{ label: '19:30', value: '19:30' },
	{ label: '20:00', value: '20:00' },
	{ label: '21:00', value: '21:00' },
	{ label: '22:00', value: '22:00' },
];

export default function TimeInput(props: IProps) {
	function handleChange(v: unknown) {
		if (props.onChange) {
			props.onChange((v as TValue).value);
		}
	}

	return (
		<Select
			styles={{
				container(base) {
					return { ...base, minWidth: '100%' };
				},
			}}
			placeholder="hh:mm"
			{...props}
			components={{ DropdownIndicator: null }}
			options={options}
			value={options.find((op) => op.value === props.value)!}
			onChange={handleChange}
			formatCreateLabel={(v) => v}
			isValidNewOption={(input) => {
				const value = input.trim();
				return /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value);
			}}
			noOptionsMessage={() => t('Invalid')}
		/>
	);
}

interface TValue {
	key: string;
	value: string;
}
